import { bool, number, object, oneOf, string } from "prop-types";
import { Grid } from "@material-ui/core";
import { ScrollButton } from "./ScrollButton";
import classnames from "classnames";

export const ScrollButtonContainer = ({
  className,
  inTable=true,
  ...scrollButtonProps
}) => (
  <Grid
    item container
    alignItems="center"
    justifyContent="flex-end"
    className={classnames("h-24", inTable ? "relative w-full z-20" : "w-max")}
    style={{ minWidth: !inTable && 48 }}
  >
    <ScrollButton
      direction="left"
      className={classnames("preset-scrollButton", className)}
      { ...scrollButtonProps }
    />
    <ScrollButton
      direction="right"
      className={classnames("preset-scrollButton", className)}
      { ...scrollButtonProps }
    />
  </Grid>
)

ScrollButtonContainer.propTypes = {
  containerRef: object.isRequired,
  className: string,
  style: object,
  direction: oneOf(["left", "right"]),
  scrollSpeed: number,
  scrollReachedStart: bool,
  scrollReachedEnd: bool,
  inTable: bool,
};